import { Icon } from '@eventbrite/eds-icon';
import {
    ChevronDownChunky,
    ChevronUpChunky,
} from '@eventbrite/eds-iconography';
import React, { useRef, useState } from 'react';
import {
    getHeapDataAttribute,
    HeapAttributes,
} from '../../../../../utils/heap-data';
import { DropdownContainerProps } from '../../../../types';
import { Dropdown } from '../Dropdown';
import styles from './DesktopDropdown.module.scss';

const DesktopDropdown = ({
    dropdownItems,
    heapIdentifier,
    translatedText,
}: DropdownContainerProps) => {
    const { Teams, Features, Components, Actions } = HeapAttributes;
    const dropdownRef = useRef<HTMLDivElement>(null);
    const [isOpen, setIsOpen] = useState(false);

    const pointerHandler = (e: React.PointerEvent) => {
        if (dropdownRef.current === document.activeElement) {
            /**
             * Prevent Default is used to prevent the browser from doing
             * it's default action on pointerDown
             */
            e.preventDefault();
            dropdownRef?.current?.blur();
            setIsOpen(false);
        }
    };

    const handleFocus = () => {
        setIsOpen(true);
    };

    const handleBlur = () => {
        setIsOpen(false);
    };

    return (
        <div
            data-heap-id={getHeapDataAttribute({
                team: Teams.SEO,
                feature: Features.GlobalNav,
                component: Components.Dropdown,
                name: heapIdentifier.replaceAll(' ', '-').toLowerCase(),
                action: Actions.Click,
            })}
            data-testid="global-nav-desktop-dropdown"
            className={styles.desktopDropdown}
        >
            <div
                className={styles.dropdownTitle}
                tabIndex={0}
                ref={dropdownRef}
                onPointerDown={pointerHandler}
                onFocus={handleFocus}
                onBlur={handleBlur}
                aria-expanded={isOpen}
                role="button"
            >
                <span>{translatedText}</span>
                <span className={styles.arrowIcons}>
                    <Icon type={<ChevronUpChunky />} />
                    <Icon type={<ChevronDownChunky />} />
                </span>
            </div>
            {isOpen && <Dropdown dropdownItems={dropdownItems} />}
        </div>
    );
};

export default DesktopDropdown;
